<section class="title-bar content-padding first-item content-padding">
    <div class="wrapper">
      <h2 class="left">Duplica prodotto: {{ product?.id }}</h2>
      <button class="btn btn-red right" (click)="delete()" *ngIf="product?.id && groups.includes('admin')">
        Elimina<i class="ml-10 far fa-trash-alt"></i>
      </button>
      <br class="clear">
    </div>
  </section>
  
  <section class="content-padding darker">
    <div class="narrow-wrapper">
      <form class="has-cols product-form" [formGroup]="_productForm" (ngSubmit)="onDuplicate()" *ngIf="_productForm">
        <div class="product-info-box">
          <fieldset>
            <legend>DETTAGLI DEL PRODOTTO:</legend>
            <div class="col-50 grid-element">
              <label for="name">Nome{{ _productForm.get("name") | required }}</label>
              <input type="text" name="name" formControlName="name">
              <app-error-html-handler [ctrl]="_productForm.get('name')" [messages]="formValidationMsgs.name">
              </app-error-html-handler>
            </div>

            <div class="col-50 grid-element" *ngIf="groups.includes('admin')">
              <label for="sku">Partners</label>
              <select formControlName="partner" (change)="handlePartnerChange($event.target.value)">
                 <option value="">Partner</option>
                 <option *ngFor="let partner of partners" [value]="partner?.id"> {{partner.businessName}}</option>
               </select>
            </div>
      
            <div class="col-50 grid-element">
              <label for="category">Prodotto Categoria{{ _productForm.get("productCategory") | required }}</label>
              <ng-select 
                class="product-category"
                [multiple]="false" 
                [hideSelected]="true"
                [closeOnSelect]="true"
                formControlName="productCategory"
                (change)="handleProductCategoryChange($event)"
                >
                <ng-option *ngFor="let productCategory of productCategories" [value]="productCategory.id">
                  {{ productCategory?.categoryName }}
                </ng-option>
              </ng-select>
              <app-error-html-handler [ctrl]="_productForm.get('productCategory')" [messages]="formValidationMsgs.productCategory">
              </app-error-html-handler>
            </div>

            <div class="product-info-box" *ngIf="productCategoryMetaFields.length > 0">
              <br class="clear">
              <fieldset>
                <legend>CAMPI ANAGRAFICI:</legend>
                <div formArrayName="productCategoryMetaFields">
                  <div class="col-100 grid-element" *ngFor="let field of productCategoryMetaFields; let i = index">
                    <label>{{ field.fieldName }} {{ (field.type === '1' || ( (field.type === '3') && ( groups.includes('admin') || groups.includes('operation') ) ) ) ? "*" : '' }}</label>
                    <textarea [formControlName]="i" rows="5"></textarea>
                    <app-error-html-handler 
                      [ctrl]="metaFields.controls[i]" 
                      [messages]="formValidationMsgs[field.fieldName]">
                    </app-error-html-handler>
                  </div>
                </div>
              </fieldset>
            </div>
      
            <div class="col-50 grid-element">
              <label for="sku">SKU</label>
              <input type="text" name="sku" formControlName="sku">
              <app-error-html-handler [ctrl]="_productForm.get('sku')" [messages]="formValidationMsgs.sku"></app-error-html-handler>
            </div>

            <div class="col-50 grid-element">
              <label for="ggDispMin">Giorni Preparazione{{ _productForm.get("ggDispMin") | required }}</label>
              <input type="number" name="ggDispMin" formControlName="ggDispMin">
              <app-error-html-handler [ctrl]="_productForm.get('ggDispMin')" [messages]="formValidationMsgs.ggDispMin"></app-error-html-handler>
            </div>

            <div class="col-100 grid-element">
              <label for="productAdvantageDesc">PLUS DEL PRODOTTO (max 80 caratteri){{ _productForm.get("productAdvantageDesc") | required }}</label>
              <textarea formControlName="productAdvantageDesc" rows="2" placeholder="Scrivi una descrizione"></textarea>
              <app-error-html-handler [ctrl]="_productForm.get('productAdvantageDesc')" [messages]="formValidationMsgs.productAdvantageDesc"></app-error-html-handler>
            </div>
      
            <div class="col-100 grid-element">
              <label for="description">Descrizione{{ _productForm.get("description") | required }}</label>
              <textarea formControlName="description" rows="5" placeholder="Scrivi una descrizione"></textarea>
            </div>
    
            <div class="col-50 grid-element">
              <label for="price">Prezzo{{ _productForm.get("price") | required }}</label>
              <input type="number" min="0" name="price" formControlName="price">
              <app-error-html-handler [ctrl]="_productForm.get('price')" [messages]="formValidationMsgs.price">
              </app-error-html-handler>
            </div>

            <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <label for="shopifyPrice">Prezzo pubblico{{ _productForm.get("shopifyPrice") | required }}</label>
              <input type="number" min="0" name="shopifyPrice" formControlName="shopifyPrice">
              <app-error-html-handler [ctrl]="_productForm.get('shopifyPrice')" [messages]="formValidationMsgs.shopifyPrice"></app-error-html-handler>
            </div>
    
            <div class="col-50 grid-element">
              <label for="line">Linea{{ _productForm.get("line") | required }}</label>
              <input type="text" name="line" formControlName="line">
              <app-error-html-handler [ctrl]="_productForm.get('line')" [messages]="formValidationMsgs.line">
              </app-error-html-handler>
              <div style="font-size: smaller;">Ogni elemento è separato da ; (punto e virgola).</div>
            </div>

            <div class="col-50 grid-element">
              <label for="stock">INVENTARIO{{ _productForm.get("productAvailability") | required }}</label>
              <input type="number" name="stock" formControlName="productAvailability">
              <app-error-html-handler [ctrl]="_productForm.get('productAvailability')" [messages]="formValidationMsgs.productAvailability"></app-error-html-handler>
            </div>
    
            <!--
            <div class="col-50 grid-element">
              <label for="stock">Stock{{ _productForm.get("stock") | required }}</label>
              <input type="text" name="stock" formControlName="stock">
              <app-error-html-handler [ctrl]="_productForm.get('stock')" [messages]="formValidationMsgs.stock">
              </app-error-html-handler>
              <div style="font-size: smaller;">Ogni elemento è separato da ; (punto e virgola).</div>
            </div>
            -->
      
            <!--
            <div class="col-50 grid-element">
              <label for="image">Immagine{{ _productForm.get("image") | required }}</label>
              <div *ngIf="product?.image && !removeFile">
                <a style="float: right; width: auto; color: red; cursor: pointer;" (click)="deleteFile();">×</a>
                <img [src]="imagePath" class="img-prodotto" style="max-height: 100px; cursor: pointer;" (click)="openImage($event)" />
              </div>
              <input type="file" name="image" (change)="onFileSelect($event)" />
              <app-error-html-handler [ctrl]="_productForm.get('image')" [messages]="formValidationMsgs.image">
              </app-error-html-handler>
            </div> 
            -->

            <div class="col-50 grid-element">
              <label for="image">Immagine{{ _productForm.get("image") | required }}</label>

              <div *ngIf="imagePreviewUrl && !removeFile">
                <a
                  style="float: right; width: auto; color: red; cursor: pointer;"
                  (click)="deleteFile()"
                >
                  ×
                </a>

                <img
                  [src]="imagePreviewUrl"
                  class="img-prodotto"
                  style="max-height: 100px; cursor: pointer;"
                  (click)="openImage($event)"
                />
              </div>

              <input
                type="file"
                name="image"
                accept="image/*"
                (change)="onFileSelect($event)"
              />

              <app-error-html-handler
                [ctrl]="_productForm.get('image')"
                [messages]="formValidationMsgs.image">
              </app-error-html-handler>
            </div>

            <!--
            <div class="col-50 grid-element" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="inStock" formControlName="inStock">
                DISPONIBILE
              </label>
            </div> 
            -->

            <!--
            <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="adminApproval" formControlName="adminApproval">
                APPROVATO
              </label>
            </div>
            -->
    
            <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="unEditable" formControlName="unEditable">
                NON MODIFICABILE
              </label>
            </div> 
    
            <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="uniqueProduct" formControlName="uniqueProduct">
                PRODOTTO UNICO
              </label>
            </div>
          </fieldset>
        </div> 

        <fieldset style="margin-top: 20px;" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <legend>INVENTORY MANAGEMENT</legend>

          <div class="col-50 grid-element">
            <label class="original-label" for="controlStock">
              <input type="checkbox" name="controlStock" id="controlStock" formControlName="controlStock">
              CONTROLLA STOCK
            </label>
          </div> 

          <br class="clear">

          <div class="col-50 grid-element" *ngIf="_productForm.get('controlStock').value === true" style="margin-top: 20px;">
            <label for="stock">INVENTARIO{{ _productForm.get("productAvailability") | required }}</label>
            <input type="number" name="stock" formControlName="productAvailability">
            <app-error-html-handler [ctrl]="_productForm.get('productAvailability')" [messages]="formValidationMsgs.productAvailability"></app-error-html-handler>
          </div>
       </fieldset>

        <br class="clear">

        <div class="products-partner-box" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <fieldset>
            <legend>SHOPIFY CONNECTION:</legend>
  
            <div class="col-50 grid-element" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="adminApproval" formControlName="adminApproval">
                APPROVATO
              </label>
            </div> 
  
            <div class="col-50 grid-element" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="productStatus" formControlName="productStatus">
                PRODUCT <b>[ {{ _productForm.get('productStatus').value ? "Attivo" : "Disattivo" }} ]</b>
              </label>
            </div> 

            <div class="col-50 grid-element" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="notPhysical" formControlName="notPhysical">
                NOT PHYSICAL
              </label>
            </div>

            <br class="clear">

            <fieldset style="margin-top: 20px;">
              <legend>SELECT PLATFORMS</legend>

              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="isDeluxyProduct" formControlName="isDeluxyProduct" (change)="handleShopCheckbox($event, 'deluxy')">
                  DELUXY <b>[deluxy.it]</b>
                </label>
              </div>
              <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isDeluxyProduct').value}" style="margin-top: 20px;">
                <label for="deluxyDescription">DELUXY DESCRIPTION</label>
                <div [ngxSummernote]="summerNoteConfig" formControlName="deluxyDescription"></div>
                <app-error-html-handler [ctrl]="_productForm.get('deluxyDescription')" [messages]="formValidationMsgs.deluxyDescription"></app-error-html-handler>
              </div>

              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="isCakeProduct" formControlName="isCakeProduct" (change)="handleShopCheckbox($event, 'cake')">
                  CAKEDESIGN <b>[cakedesign.me]</b>
                </label>
              </div>
              <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isCakeProduct').value}" style="margin-top: 20px;">
                <label for="cakeDescription">CAKEDESIGN DESCRIPTION</label>
                <div [ngxSummernote]="summerNoteConfig" formControlName="cakeDescription"></div>
                <app-error-html-handler [ctrl]="_productForm.get('cakeDescription')" [messages]="formValidationMsgs.cakeDescription"></app-error-html-handler>
              </div>

              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="isFlowersProduct" formControlName="isFlowersProduct" (change)="handleShopCheckbox($event, 'flowers')">
                  FLOWERS <b>[deluxyflowers.com]</b>
                </label>
              </div>
              <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isFlowersProduct').value}" style="margin-top: 20px;">
                <label for="flowersDescription">FLOWERS DESCRIPTION</label>
                <div [ngxSummernote]="summerNoteConfig" formControlName="flowersDescription"></div>
                <app-error-html-handler [ctrl]="_productForm.get('flowersDescription')" [messages]="formValidationMsgs.flowersDescription"></app-error-html-handler>
              </div>

              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="isBusinessProduct" formControlName="isBusinessProduct" (change)="handleShopCheckbox($event, 'business')">
                  BUSINESS <b>[business.deluxy.it]</b>
                </label>
              </div>
              <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isBusinessProduct').value}" style="margin-top: 20px;">
                <label for="businessDescription">BUSINESS DESCRIPTION</label>
                <div [ngxSummernote]="summerNoteConfig" formControlName="businessDescription"></div>
                <app-error-html-handler [ctrl]="_productForm.get('businessDescription')" [messages]="formValidationMsgs.businessDescription"></app-error-html-handler>
              </div><div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="isDeluxyExperienceProduct" formControlName="isDeluxyExperienceProduct" (change)="handleShopCheckbox($event, 'deluxyExperience')">
                  DELUXY EXPERIENCE <b>[deluxyexperience.it]</b>
                </label>
              </div>
              <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isDeluxyExperienceProduct').value}" style="margin-top: 20px;">
                <label for="deluxyExperienceDescription">DELUXY EXPERIENCE DESCRIPTION</label>
                <div [ngxSummernote]="summerNoteConfig" formControlName="deluxyExperienceDescription"></div>
                <app-error-html-handler [ctrl]="_productForm.get('deluxyExperienceDescription')" [messages]="formValidationMsgs.deluxyExperienceDescription"></app-error-html-handler>
              </div>
              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="isDeluxyDotComProduct" formControlName="isDeluxyDotComProduct" (change)="handleShopCheckbox($event, 'deluxyDotCom')">
                  DELUXY DOT COM <b>[deluxy.com]</b>
                </label>
              </div>
              <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isDeluxyDotComProduct').value}" style="margin-top: 20px;">
                <label for="deluxyDotComDescription">DELUXY DOT COM DESCRIPTION</label>
                <div [ngxSummernote]="summerNoteConfig" formControlName="deluxyDotComDescription"></div>
                <app-error-html-handler [ctrl]="_productForm.get('deluxyDotComDescription')" [messages]="formValidationMsgs.deluxyDotComDescription"></app-error-html-handler>
              </div>
            </fieldset>
          </fieldset>
        </div>

        <br class="clear">

        <div class="products-partner-box" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <fieldset>
            <legend>PRODUCTS PARTNER:</legend>
            <div class="col-50 grid-element" *ngIf="(groups.includes('admin') || groups.includes('operation'))" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="visibleToOtherPartners" formControlName="visibleToOtherPartners">
                Visible To Other Partners
              </label>
            </div> 
  
            <div class="grid-element-full" [ngClass]="{'hidden': !_productForm.get('visibleToOtherPartners').value}" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
              <label style="position: relative; top: 20px;">PARTNER</label>
              <div formArrayName="productPartners">
                <div class="offer-products" *ngFor="let productForm of _productForm.get('productPartners').controls; let i = index">
                  <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                    <label for=""></label>
                    <div style="display: table-cell; width: 19px;">
                      <i class="far fa-times-circle hvr-grow remove-product"  (click)="removePartner(i)"></i>
                    </div>
                    <div class="product-q" formGroupName="partner">
                      <div class="porduct-qty">
                        <div class="province-input">
                          <label for=""></label>
                          <ng-select 
                            formControlName="id"
                            [searchable]="true" 
                            [clearable]="true"
                            [virtualScroll]="true"
                            >
                            <ng-option *ngFor="let partner of partners" [value]="partner?.id" [disabled]="isPartnerOptionDisabled(partner)">{{partner.businessName}}</ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <br>
                    <app-error-html-handler [ctrl]="productForm?.controls?.partner?.controls?.id" [messages]="formValidationMsgs?.productPartners?.partner.id">
                    </app-error-html-handler>
                  </div>
                </div>
              </div>
              <div class="center" style="width: 100%;">
                <button class="btn mt-0" (click)="$event.preventDefault(); addPartner()">
                  Aggiungi Partner<i class="ml-10 fas fa-plus"></i>
                </button>
              </div>
            </div>
          </fieldset>
        </div>

        <br class="clear">
        <div class="products-partner-box" *ngIf="groups.includes('admin') || groups.includes('operation')">
          <fieldset>
            <legend>SUPER PRODOTTO:</legend>
            <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="isSuperProduct" formControlName="isSuperProduct">
                Super Prodotto
              </label>
            </div> 

            <div class="grid-element-full" [ngClass]="{'hidden': !_productForm.get('isSuperProduct').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">
              <label style="position: relative; top: 20px;">Prodotti</label>
              <div formArrayName="superProducts">
                <div class="offer-products" *ngFor="let productForm of _productForm.get('superProducts').controls; let i = index">
                  <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                    <label for=""></label>
                    <div style="display: table-cell; width: 19px;">
                      <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProduct(i)"></i>
                    </div>
                    <div class="product-q" formGroupName="product">
                      <div class="porduct-qty">
                        <div class="province-input">
                          <label for=""></label>
                          <ng-select 
                            formControlName="id"
                            [searchable]="true" 
                            [clearable]="true"
                            [virtualScroll]="true"
                            >
                            <ng-option *ngFor="let product of products" [value]="product?.id" [disabled]="isProductOptionDisabled(product)">{{product.name}}</ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <br>
                    <app-error-html-handler [ctrl]="productForm?.controls?.product.controls?.id" [messages]="formValidationMsgs?.superProducts?.product.id"></app-error-html-handler>
                  </div>
                </div>
              </div>
              <div class="center" style="width: 100%;">
                <button class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
                  Aggiungi Prodotto<i class="ml-10 fas fa-plus"></i>
                </button>
              </div>
            </div>
          </fieldset>
        </div>

        <br class="clear">
        <div class="products-variant-box" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('partner')">
          <fieldset>
            <legend>PRODOTTO VARIANTI:</legend>

            <div class="col-50 grid-element" style="margin-top: 20px;">
              <label class="original-label">
                <input type="checkbox" name="productHasVariants" formControlName="productHasVariants" (change)="productHasVariant($event)">
                Il prodotto ha variant?<b>[{{ _productForm.get('productHasVariants').value ? "SI" : "NO" }}]</b>
              </label>
            </div>

            <br class="clear">
            <div class="col-50 grid-element" [ngClass]="{'hidden': !_productForm.get('productHasVariants').value}">
              <label for="productOptionTitle">Nome Opzione{{ _productForm.get("productOptionTitle") | required }}</label>
              <input type="text" name="productOptionTitle" formControlName="productOptionTitle">
              <app-error-html-handler [ctrl]="_productForm.get('productOptionTitle')" [messages]="formValidationMsgs.productOptionTitle"></app-error-html-handler>
            </div>

            <div formArrayName="productVariants" [ngClass]="{'hidden': !_productForm.get('productHasVariants').value}">
              <div style="margin-top: 20px;" *ngFor="let variant of _productForm.get('productVariants').controls; let i = index">
                <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                  <fieldset>
                    <div class="col-50 grid-element">
                      <label for="variantName">Nome VARIANTI{{ variant.get("variantName") | required }}</label>
                      <input type="text" name="variantName" formControlName="variantName">
                      <app-error-html-handler [ctrl]="variant.get('variantName')" [messages]="formValidationMsgs.productVariants.variantName"></app-error-html-handler>
                    </div>
            
                    <div class="col-50 grid-element">
                      <label for="variantSku">VARIANTI SKU{{ variant.get("variantSku") | required }}</label>
                      <input type="text" name="variantSku" formControlName="variantSku">
                      <app-error-html-handler [ctrl]="variant.get('variantSku')" [messages]="formValidationMsgs.productVariants.variantSku"></app-error-html-handler>
                    </div>
        
                    <div class="col-50 grid-element">
                      <label for="variantGgDispMin">VARIANTI Giorni Preparazione{{ variant.get("variantGgDispMin") | required }}</label>
                      <input type="number" min="0" name="variantGgDispMin" formControlName="variantGgDispMin">
                      <app-error-html-handler [ctrl]="variant.get('variantGgDispMin')" [messages]="formValidationMsgs.productVariants.variantGgDispMin"></app-error-html-handler>
                    </div>
            
                    <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
                      <label for="variantPrice">VARIANTI Prezzo{{ variant.get("variantPrice") | required }}</label>
                      <input type="number" min="0" name="variantPrice" formControlName="variantPrice">
                      <app-error-html-handler [ctrl]="variant.get('variantPrice')" [messages]="formValidationMsgs.productVariants.variantPrice"></app-error-html-handler>
                    </div>

                    <div class="col-50 grid-element">
                      <label for="variantShopifyPrice">VARIANTI Prezzo pubblico{{ variant.get("variantShopifyPrice") | required }}</label>
                      <input type="number" min="0" name="variantShopifyPrice" formControlName="variantShopifyPrice">
                      <app-error-html-handler [ctrl]="variant.get('variantShopifyPrice')" [messages]="formValidationMsgs.productVariants.variantShopifyPrice"></app-error-html-handler>
                    </div>

                    <div class="col-50 grid-element">
                      <label for="variantAvailability">VARIANTI INVENTARIO{{ _productForm.get("variantAvailability") | required }}</label>
                      <input type="number" name="variantAvailability" formControlName="variantAvailability">
                      <app-error-html-handler [ctrl]="_productForm.get('variantAvailability')" [messages]="formValidationMsgs.variantAvailability"></app-error-html-handler>
                    </div>

                    <fieldset style="margin-top: 20px;" *ngIf="groups.includes('admin') || groups.includes('operation')">
                      <legend>INVENTORY MANAGEMENT(VARIANTI)</legend>

                      <div class="col-50 grid-element">
                        <label class="original-label" for="controlVariantStock_{{i}}">
                          <input type="checkbox" name="controlVariantStock" id="controlVariantStock_{{i}}" formControlName="controlVariantStock">
                          CONTROLLA STOCK(VARIANTI)
                        </label>
                      </div> 

                      <br class="clear">

                      <div class="col-50 grid-element" *ngIf="variant.get('controlVariantStock').value === true" style="margin-top: 20px;">
                        <label for="variantAvailability">VARIANTI INVENTARIO{{ variant.get("variantAvailability") | required }}</label>
                        <input type="number" name="variantAvailability" formControlName="variantAvailability">
                        <app-error-html-handler [ctrl]="variant.get('variantAvailability')" [messages]="formValidationMsgs.variantAvailability"></app-error-html-handler>
                      </div>
                    </fieldset>
  
                    <!--
                    <div class="col-50 grid-element" style="margin-top: 20px;">
                      <label class="original-label">
                        <input type="checkbox" name="variantInStock" formControlName="variantInStock">
                        DISPONIBILE(VARIANTI)
                      </label>
                    </div>
                    -->

                    <div class="center" style="width: 100%; margin-top: 20px;">
                      <button class="btn mt-5 btn-red hvr-grow mr-10" (click)="$event.preventDefault(); removeProductVariant(i)">
                        Rimuovi<i class="ml-10 far fa-trash-alt"></i>
                      </button>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <div class="center" style="width: 100%; margin-top: 20px;" [ngClass]="{'hidden': !_productForm.get('productHasVariants').value}">
              <button class="btn mt-5" (click)="$event.preventDefault(); addProductVariant()">
                Aggiungi Varianti<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </fieldset>
        </div>

        <div class="center" style="margin-top: 10px;">
          <button 
            class="btn hvr-shrink center" 
            (click)="$event.preventDefault(); onDuplicate()"
            [disabled]="!_productForm?.valid || tmpBtnDisabled">
            Salva
            <i class="ml-10 far fa-save"></i>
          </button>
        </div>

        <div class="error-box" style="margin-top: 15px;" *ngIf="getErrorMessages().length > 0">
          <fieldset>
            <legend>CAMPI OBBLIGATORI:</legend>
            <div>
              <ul class="error-list">
                <li *ngFor="let error of getErrorMessages()">
                  {{ translateErrorMessage(error) }}
                </li>
              </ul>
            </div>
          </fieldset>
        </div>
      </form>
      <br class="clear">
    </div>
  </section>
  